/**
 * Wraps occurrences of `query` terms in `<mark>` tags for use with v-html.
 * Input is HTML-escaped to prevent XSS.
 */
export function highlight(text: string | null | undefined, query: string, preserveBreaks = false): string {
    const safe = (text ?? '—').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    const formatted = preserveBreaks ? safe.replace(/&lt;br\s*\/?&gt;/gi, '<br>') : safe
    if (!query.trim() || !text) return formatted
    const terms = query.trim().split(/\s+/).filter(Boolean)
    const pattern = terms
        .map((t) => t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
        .sort((a, b) => b.length - a.length)
        .join('|')
    return formatted.replace(new RegExp(`(${pattern})`, 'gi'), '<mark>$1</mark>')
}
